import { useContext } from 'react';
import { PageContext } from '@sleepunique/context/PageContext';
import { PageId } from '@sleepunique/types/view-id-type';

const usePreviousStep = () => {
  const { page, setPage } = useContext(PageContext);
  const pageIndex: number = Object.keys(PageId).indexOf(page);

  return () => {
    const previousPage: PageId = Object.keys(PageId)[pageIndex - 1] as PageId;
    if (!previousPage || typeof setPage === 'undefined') return;
    setPage(previousPage);
  };
};

export default usePreviousStep;
